import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { selectPackage } from '../../../../redux/reducers';
import {
  selectActivePackageId,
  selectIsPackagesAvailable,
  selectFormattedPackages,
} from '../../../../selectors/publishTerms';
import { Packages } from './Packages';

export const PackagesContainer = () => {
  const isMobile = useIsMobileDevice();
  const activePackageId = useSelector(selectActivePackageId);
  const isPackagesAvailable = useSelector(selectIsPackagesAvailable);
  const packages = useSelector(selectFormattedPackages(isMobile));
  const dispatch = useDispatch<TDispatch>();

  const handleChangePackage = React.useCallback(
    (newPackageId: string) => {
      dispatch(selectPackage(newPackageId));
    },
    [dispatch],
  );

  if (!isPackagesAvailable) {
    return null;
  }

  return <Packages activePackageId={activePackageId} packages={packages} onChangePackage={handleChangePackage} />;
};
